import { api } from '@/utils/api';
import { investigationContract, InvestigationWorkspace, InvestigatorCandidate } from '@/types/incidentInvestigation';

// The global axios interceptor returns the raw Axios response while the server wraps
// every payload in a success/data envelope, so these helpers unwrap `response.data.data`.
export const investigationApi = {
  getWorkspace: async (incidentId: string): Promise<InvestigationWorkspace> => {
    const response = await api.get(investigationContract.workspace(incidentId));
    return response.data?.data ?? response.data;
  },
  getAssignableInvestigators: async (): Promise<InvestigatorCandidate[]> => {
    const response = await api.get(investigationContract.assignableInvestigators());
    return response.data?.data ?? [];
  },
  assignInvestigator: async (incidentId: string, payload: { investigatorId: number; reason: string }) => {
    const response = await api.patch(investigationContract.investigator(incidentId), payload);
    return response.data?.data;
  },
  addWhy: (incidentId: string, payload: unknown) => api.post(investigationContract.why(incidentId), payload),
  editWhy: (incidentId: string, nodeId: string, payload: unknown) => api.patch(`${investigationContract.why(incidentId)}/${nodeId}`, payload),
  confirmWhy: (incidentId: string, nodeId: string, payload: unknown) => api.post(`${investigationContract.why(incidentId)}/${nodeId}/confirm`, payload),
  setFactors: (incidentId: string, payload: unknown) => api.put(investigationContract.factors(incidentId), payload),
  // S3-SOL-F02: the server-side 5M factor catalog — selectable factors for a
  // fresh investigation whose workspace has no factor rows yet.
  getFactors: async (): Promise<Array<{ factorId: string; label: string; category: string }>> => {
    const response = await api.get(investigationContract.factorCatalog());
    return response.data?.data ?? [];
  },
  setRootCause: (incidentId: string, payload: unknown) => api.put(investigationContract.rootCause(incidentId), payload),
  createAction: (incidentId: string, payload: unknown) => api.post(investigationContract.actions(incidentId), payload),
  completeAction: (incidentId: string, actionId: string, payload: unknown) => api.post(`${investigationContract.actions(incidentId)}/${actionId}/complete`, payload),
  requestEvidenceRemoval: (incidentId: string, evidenceId: string, payload: unknown) => api.post(`${investigationContract.evidence(incidentId)}/${evidenceId}/remove-request`, payload),
};